import React from "react";

export default function Hero() {
  return (
    <section
      data-testid="hero"
      className="relative min-h-[100svh] w-full overflow-hidden grain bg-bone"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&w=2400&q=85"
          alt="Modern Australian architecture"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/30 via-ink/10 to-bone" />
      </div>

      {/* Top label rail */}
      <div className="relative z-10 w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 pt-32 md:pt-40 flex items-start justify-between">
        <p className="label text-bone/90">— Adelaide · Australia</p>
        <p className="label text-bone/90 hidden sm:block">Index 01 / Hero</p>
      </div>

      {/* Headline */}
      <div className="relative z-10 w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 mt-16 md:mt-24">
        <h1 className="display text-bone text-[18vw] md:text-[14vw] lg:text-[11.5rem] leading-[0.82] tracking-tighter">
          Design.
        </h1>
        <h1 className="display text-bone text-[18vw] md:text-[14vw] lg:text-[11.5rem] leading-[0.82] tracking-tighter md:pl-[18%] -mt-2 md:-mt-6">
          <span className="italic font-light">Draft.</span>
        </h1>
        <h1 className="display text-bone text-[18vw] md:text-[14vw] lg:text-[11.5rem] leading-[0.82] tracking-tighter md:pl-[40%] -mt-2 md:-mt-6">
          Build.
        </h1>
      </div>

      {/* Bottom bar */}
      <div className="absolute bottom-0 left-0 right-0 z-10 bg-ink text-bone py-5 overflow-hidden">
        <div className="flex animate-marquee whitespace-nowrap">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={k} className="flex shrink-0 items-center gap-12 px-12 text-[12px] uppercase tracking-[0.28em]">
              <span>Residential</span><span className="text-clay">✦</span>
              <span>Commercial</span><span className="text-clay">✦</span>
              <span>Industrial</span><span className="text-clay">✦</span>
              <span>Drafting · BIM · Revit</span><span className="text-clay">✦</span>
              <span>Council documentation</span><span className="text-clay">✦</span>
              <span>Construction management</span><span className="text-clay">✦</span>
              <span>Since 2018</span><span className="text-clay">✦</span>
              <span>6 Australian states</span><span className="text-clay">✦</span>
            </div>
          ))}
        </div>
      </div>

      {/* Side caption */}
      <div className="absolute bottom-28 left-6 sm:left-8 lg:left-12 z-10 max-w-md hidden md:block">
        <p className="text-bone/90 font-body text-base leading-relaxed">
          End-to-end architectural and building solutions across Australia — crafted with precision, delivered with conviction.
        </p>
        <div className="flex gap-4 mt-8">
          <a
            href="#work"
            data-testid="hero-view-work"
            className="px-6 py-3 bg-bone text-ink text-[12px] uppercase tracking-[0.24em] hover:bg-clay hover:text-bone transition-colors"
          >
            View our work
          </a>
          <a
            href="#estimator"
            data-testid="hero-estimator"
            className="px-6 py-3 border border-bone text-bone text-[12px] uppercase tracking-[0.24em] hover:bg-bone hover:text-ink transition-colors"
          >
            Estimate a build
          </a>
        </div>
      </div>

      {/* Right vertical caption */}
      <div className="absolute right-6 bottom-32 z-10 hidden lg:block rotate-90 origin-right">
        <p className="label text-bone/70">Scroll · 01 — Hero</p>
      </div>
    </section>
  );
}
